import React from 'react'

import { getHiringDataNames, hasAccessToThis } from 'services/Utilities'
import { t } from 'translations'

const UserHiringData = ({ hiringData, canBeNull }) => {
  if (!hasAccessToThis('hiringDataSee')) return canBeNull ? t('components.MISSING_PERMISSIONS') : null
  if (!hiringData.length) return canBeNull ? t('components.NO_HIRING_DATA') : null

  return <>{getHiringDataNames(hiringData, { withDates: true })}</>
}

export default UserHiringData

UserHiringData.defaultProps = {
  hiringData: []
}
